export enum StaticLocales {
  ES = 'es',
  EN_GB = 'en-GB',
  EN = 'en',
  IT = 'it',
  FR = 'fr',
  TR = 'tr',
  ZH_CN = 'zh-CN',
}
